import type { ReactNode } from "react";

export type HeaderIconName =
  "add" | "search" | "shortcuts" | "copy" | "copied" | "refresh";

export function HeaderIconButton({
  name,
  label,
  title,
  onClick,
}: {
  readonly name: HeaderIconName;
  readonly label: string;
  readonly title?: string;
  readonly onClick: () => void;
}) {
  return (
    <button
      className="header-icon-button"
      type="button"
      aria-label={label}
      title={title ?? label}
      onClick={onClick}
    >
      <HeaderIcon name={name} />
    </button>
  );
}

export function HeaderIcon({ name }: { readonly name: HeaderIconName }) {
  return (
    <svg
      className="header-icon-button__glyph"
      viewBox="0 0 20 20"
      aria-hidden="true"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {headerIconGraphic(name)}
    </svg>
  );
}

function headerIconGraphic(name: HeaderIconName): ReactNode {
  if (name === "search") {
    return (
      <>
        <circle cx="8.5" cy="8.5" r="4.2" />
        <path d="M11.7 11.7 16 16" />
      </>
    );
  }
  if (name === "shortcuts") {
    return (
      <>
        <rect x="3.2" y="5.2" width="13.6" height="9.6" rx="1.2" />
        <path d="M6.2 12.2h7.6" />
        <path d="M6.8 8.2h2" />
        <path d="M11.2 8.2h2" />
      </>
    );
  }
  if (name === "copy") {
    return (
      <>
        <rect x="7.2" y="7.2" width="8.3" height="8.3" />
        <path d="M12.5 7.2V4.5H4.5v8H7.2" />
      </>
    );
  }
  if (name === "copied") {
    return <path d="M4.5 10.5 8.2 14.2 15.5 5.8" />;
  }
  if (name === "refresh") {
    return (
      <>
        <path d="M15.4 10a5.4 5.4 0 1 1-1.58-3.82" />
        <path d="M15.4 4.6v3.2h-3.2" />
      </>
    );
  }
  return (
    <>
      <path d="M10 4.5v11" />
      <path d="M4.5 10h11" />
    </>
  );
}
